import clsx from 'clsx';
import React, { FC, ReactNode } from 'react'
import { KTIcon } from '@/_metronic/helpers'

type Props = {
  icon: string
  color: string
  title: ReactNode
  value: ReactNode
  isLoading?: boolean
}

export const IndicatorCard: FC<Props> = ({ icon, color, title, value, isLoading }) => {
  return (
    <div className={`card bg-${color} hoverable card-xl-stretch mb-xl-2`}>
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-5">
          <KTIcon iconName={icon} className='fs-3x text-white me-1' />
          <div className="text-white fw-bold fs-2">
            {isLoading === true ? (
              <i className='spinner-border fs-5x'></i>
            ) : (
              <>{value}</>
            )}
          </div>
        </div>
        <div className="text-white fw-bold fs-2">{title}</div>
      </div>
    </div>
  )
}

type SmallProps = {
  icon: string
  title: string
  color: string
  value: ReactNode
  isLoading?: boolean
  padding?: string;
}

export const SmallIndicatorCard: FC<SmallProps> = ({ icon, color, value, title, isLoading, padding }) => {
  return (
    <div className={`card bg-${color} hoverable card-xl-stretch mb-xl-2`} title={title}>
      <div className={clsx('card-body', padding)}>
        <div className="d-flex justify-content-between align-items-center">
          <KTIcon iconName={icon} className='fs-3x text-white me-1' />
          <div className="text-white fw-bold fs-2">
            {isLoading === true ? (
              <i className='spinner-border fs-5x'></i>
            ) : (
              <>{value}</>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
